module.exports = __webpack_public_path__ + "static/media/Experiencia.15366abf.png";